<template>
  <div class="wrap" :class="isSideMenuClosed ? 'collapsed' : ''">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''">
      <div class="header-sns-wrap">
        <div class="header-sns instagram"><font-awesome-icon :icon="['fab', 'instagram']" /></div>
        <div class="header-sns-title">Instagram</div>
      </div>
    </div>
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div>
        <div class="check-wrap">
          <div class="check-parts">{{ checkList.length }}名を選択中</div>
          <div class="check-parts pointer" @click="clearList"><i class="el-icon-remove-outline" style="font-size:14px;"></i>全員の選択を解除</div>
          <addListButton :checkList.sync="checkList" :checkAll_val.sync="checkAll_val" :sns_type="'instagram'" :other_sns_type="other_sns_type"/>
        </div>
      </div>
    </div>

    <!-- ユーザーページ -->
    <div class="search-page-wrap">
      <div class="data-table-title">
        <div class="data-table-title-letter">
          インフルエンサー検索
          <div class="data-table-result-count">
            該当数
            <span class="data-table-result-count-num">{{ displayResultCount }}</span>
            件
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="data-table-quick-filter" style="display:flex; align-items:center; gap:10px; margin-right:25px;">
          <el-checkbox v-model="recentPost1month">
            直近1ヶ月以内に投稿あり
          </el-checkbox>
        </div>
        <div class="data-table-menu">
          <windowSwitch />
          <el-dropdown :hide-on-click="false" trigger="click">
            <el-button type="info" style="margin-left:10px">
              表示項目
              <font-awesome-icon icon="caret-down" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><el-checkbox v-model="item.account_name" disabled>ユーザー名</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.sns">SNS</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.gender">性別</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.age">年齢</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.area">関連エリア</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.bio">プロフィール</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.followers">フォロワー数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.followers_growth_rate_90">フォロワー増加率</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.following">フォロー数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.average_like">平均いいね数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.average_comments">平均コメント数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_rate">リール視聴率中央値(合計)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_rate_organic">リール視聴率中央値(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_rate_pr">リール視聴率中央値(PR)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_count">リール再生数中央値(合計)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_count_organic">リール再生数中央値(ｵｰｶﾞﾆｯｸ)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.median_video_play_count_pr">リール再生数中央値(PR)</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.egr">平均EGR</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.pr_rate">PR率</el-checkbox></el-dropdown-item>
              <el-tooltip placement="right" :disabled="view_influencer_audience_enabled">
                <div class="activate-popover" slot="content">
                  <div class="pointer" @click="toSetting">アップグレード</div>
                  でご利用いただけます
                </div>
                <el-dropdown-item><el-checkbox :disabled="!view_influencer_audience_enabled" v-model="item.gender_ratio">フォロワー男女比</el-checkbox></el-dropdown-item>
              </el-tooltip>
              <el-tooltip placement="right" :disabled="view_influencer_audience_enabled">
                <div class="activate-popover" slot="content">
                  <div class="pointer" @click="toSetting">アップグレード</div>
                  でご利用いただけます
                </div>
                <el-dropdown-item><el-checkbox :disabled="!view_influencer_audience_enabled" v-model="item.main_audience">フォロワー年齢層</el-checkbox></el-dropdown-item>
              </el-tooltip>
              <el-dropdown-item><el-checkbox v-model="item.tag">カスタマイズタグ</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.recent_post">直近の投稿</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.created_at">追加日</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.score">SCORE</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.category">関連カテゴリ</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.attribute_person_title">人物・肩書</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.attribute_specialty_categories_genres">得意カテゴリー・ジャンル</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.attribute_post_format">投稿形式</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.report_count">レポート起用回数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_egr">レポート投稿平均EGR</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_reach_count">レポート投稿平均リーチ数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_like_count">レポート投稿平均いいね数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_comments_count">レポート投稿平均コメント数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_saves_count">レポート投稿平均保存数</el-checkbox></el-dropdown-item>
              <el-dropdown-item><el-checkbox v-model="item.avg_report_cost">レポート投稿平均コスト</el-checkbox></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- データテーブル全体 -->
      <!-- テーブルタイトル -->
      <div class="data-table">
        <div class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account" :style="item.bio == false ? 'max-width:100%' : ''">
            <div class="data-table-th-checkbox">
              <el-checkbox v-model="checkAll_val" @change="checkAll" v-show="!noinfluencer"></el-checkbox>
            </div>
            <div
              class="data-table-th-picture_name pointer data-table-th-line"
              :class="[sort_key === 'account_name' ? 'data-table-sort-active' : '']"
              id="item_account_name"
              :style="'min-width:' + account_name_width"
              @click="sortBy('account_name')"
            >
              <span class="data-table-underline">ユーザー名</span>
              <font-awesome-icon
                v-if="sort_key == 'account_name'"
                :icon="sort_key == 'account_name' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'account_name' && sort_order == 'desc' ? 'arrow-down' : ''"
                style="margin-left:3px;"
              />
            </div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <tableColumn :item="'age'" :column="'age'" :css="'usergender'" :title="'年齢'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num data-table-th-line" v-if="item.age && admin_mode && activate == 20" id="item_age">生年月日候補</div>
          <div class="data-table-th-gender data-table-th-line" v-show="item.area" id="item_area">関連エリア</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">プロフィール</div>
          <tableColumn :item="'followers'" :column="'followers_count'" :css="'num'" :title="'フォロワー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'followers_growth_rate_90'" :column="'followers_growth_rate_90'" :css="'eg'" :title="'フォロワー\n増加率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'following'" :column="'following_count'" :css="'num'" :title="'フォロー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'average_like'" :column="'average_like'" :css="'eg'" :title="'平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'average_comments'" :column="'average_comments'" :css="'eg'" :title="'平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate'" :column="'median_video_play_rate'" :css="'eg'" :title="'リール視聴率中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate_organic'" :column="'median_video_play_rate_organic'" :css="'eg'" :title="'リール視聴率中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate_pr'" :column="'median_video_play_rate_pr'" :css="'eg'" :title="'リール視聴率中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count'" :column="'median_video_play_count'" :css="'eg'" :title="'リール再生数中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count_organic'" :column="'median_video_play_count_organic'" :css="'eg'" :title="'リール再生数中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count_pr'" :column="'median_video_play_count_pr'" :css="'eg'" :title="'リール再生数中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'eg'" :column="'average_engagement'" :css="'eg'" :title="'平均EG'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'average_engagement_rate'" :css="'eg'" :title="'平均EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'pr_rate'" :css="'eg'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num" v-if="item.main_audience" id="item_main_audience">フォロワー<br />年齢層</div>
          <div class="data-table-th-tag" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <div class="data-table-th-photo data-table-th-line" v-if="i_search.category.length > 0 || (i_search.keyword && item.recent_post && i_search.keyword.trim() !== '')" id="item_recent_post">
            {{ i_search.keyword ? i_search.keyword + "の関連" : getCategoryName(i_search.category) + "の" }}投稿
          </div>
          <div class="data-table-th-photo data-table-th-line" v-else v-show="item.recent_post" id="item_recent_post">直近の投稿</div>
          <tableColumn :item="'created_at'" :column="'created_at'" :css="'140'" :title="'追加日'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'score'" :column="'score'" :css="'140'" :title="'SCORE'" :item_info="item_info" @sortBy="sortBy" />
          <div
            class="data-table-th-ranking pointer data-table-th-line"
            v-show="(i_search.keyword && i_search.keyword.trim() !== '') || i_search.category.length > 0"
            @click="i_search.keyword ? sortBy('keyword') : sortBy('category')"
            v-bind:class="[sort_key === 'keyword' || sort_key === 'category' ? 'data-table-sort-active' : '']"
            id="item_ranking"
          >
            <span class="data-table-underline">
              <span v-if="i_search.keyword">{{ i_search.keyword }}</span>
              <span v-else>{{ getCategoryName(i_search.category) }}</span>
              との関連度
            </span>
            <font-awesome-icon v-if="sort_key == 'keyword' || sort_key == 'category'" :icon="sort_order == 'asc' ? 'arrow-up' : 'arrow-down'" style="margin-left:3px;" />
          </div>
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
          <div class="data-table-th-attribute" v-show="item.attribute_person_title" id="item_attribute_person_title">人物・肩書</div>
          <div class="data-table-th-attribute" v-show="item.attribute_specialty_categories_genres" id="item_attribute_specialty_categories_genres">得意カテゴリー・ジャンル</div>
          <div class="data-table-th-attribute" v-show="item.attribute_post_format" id="item_attribute_post_format">投稿形式</div>
          
          <!-- レポート関連 -->
          <tableColumn :item="'report_count'" :column="'report_count'" :css="'num'" :title="'レポート\起用回数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_egr'" :column="'avg_report_egr'" :css="'eg'" :title="'レポート投稿平均EGR'" :item_info="item_info" @sortBy="sortBy" />          
          <tableColumn :item="'avg_report_reach_count'" :column="'avg_report_reach_count'" :css="'num'" :title="'レポート投稿平均リーチ数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_like_count'" :column="'avg_report_like_count'" :css="'num'" :title="'レポート投稿平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_comments_count'" :column="'avg_report_comments_count'" :css="'num'" :title="'レポート投稿平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_saves_count'" :column="'avg_report_saves_count'" :css="'num'" :title="'レポート投稿平均保存数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_cost'" :column="'avg_report_cost'" :css="'num'" :title="'レポート投稿平均コスト'" :item_info="item_info" @sortBy="sortBy" />

        </div>

        <!-- テーブルループ -->
        <transition name="fade" v-if="noindex">
          <div class="data-table-list-nolist">
            <img src="../../assets/time.png" style="opacity:0.5" alt />
            <div style="font-size:20px; font-weight:700; margin-bottom:20px; text-align: center;">
              こちらのキーワード検索は、初回のみ時間がかかります。<br>
              5~10分後に、同じキーワードで再検索をお願いします。
            </div>
            <div class="flex-row" style="margin-bottom: 10px;">
              <div class="loader--mini blue"></div>
            </div>
            <div class="flex-row" style="margin-bottom: 20px;">
              <div v-if="index_create_progress == 10" class="flex-row" style="margin-left: 10px;">「{{ i_search.keyword }}」に関する投稿データを収集しています...</div>
              <div v-else-if="index_create_progress > 10">「{{ i_search.keyword }}」の関連度を計算しています...</div>
            </div>
            <div>
              <a href="https://help.reech.co.jp/ja/articles/5938435" target="_blank" class="router-link"
                >キーワード検索に時間がかかる理由は？ <font-awesome-icon :icon="['far', 'external-link']" style="margin-left: 3px;"
              /></a>
            </div>
          </div>
        </transition>
        <div class="data-table-list-nolist" v-else-if="noinfluencer">
          <img src="../../assets/search_image.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:700; margin-bottom:10px;">インフルエンサーが見つかりませんでした</div>
          <div style="margin-bottom: 30px;">条件を変えて検索してみましょう</div>
        </div>
        <div class="data-table-tr" v-for="(influencer, index) in list.influencer" :key="influencer.id">
          <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account" :style="item.bio == false ? 'max-width:100%' : ''">
            <div class="data-table-th-checkbox">
              <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.ig_id" :id="influencer.ig_id + 'checkbox'" />
              <label class="checkbox_inner" :for="influencer.ig_id + 'checkbox'"> </label>
            </div>
            <div class="data-table-th-picture pointer">
              <favorite :favorite="influencer.favorite" :index="index" @changeFavorite="changeFavorite" />
              <stories :ig_id="influencer.ig_id" :stories.sync="influencer.stories" :index="index"/>
              <img
                :src="influencer.profile_picture_url"
                class="data-table-profile"
                @click.exact="window_switch ? openDrawer(influencer.account_name, index, 'instagram', false) : openNewWindow(influencer.account_name, 'instagram')"
                @click.ctrl.exact="openNewWindow(influencer.account_name, 'instagram')"
                @click.meta.exact="openNewWindow(influencer.account_name, 'instagram')"
                @error="imgError(index)"
              />
            </div>
            <div class="data-table-th-account-name pointer" id="item_tr_name">
              <div
                @click.exact="window_switch ? openDrawer(influencer.account_name, index, 'instagram', false) : openNewWindow(influencer.account_name, 'instagram')"
                @click.ctrl.exact="openNewWindow(influencer.account_name, 'instagram')"
                @click.meta.exact="openNewWindow(influencer.account_name, 'instagram')"
                class="badge-wrap"
              >
                {{ influencer.account_name }}
                <img src="../../assets/badge.png" style="width:14px; height:14px; margin-left:5px" v-show="influencer.badge == '1'" />
              </div>
              <div class="data-table-th-listname" v-if="influencer.list_count > 0">
                <listIn :list_in="influencer.list_in" :list_count="influencer.list_count" v-show="permission.list.access" />
              </div>
            </div>
          </div>
          <div class="data-table-th-sns" v-show="item.sns">
            <snsIconList :other_sns="influencer.other_sns" />
          </div>
          <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
            <div class="pointer" @click="changeGender('nodisplay', influencer.ig_id, index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
            <div class="pointer" @click="changeGender('', influencer.ig_id, index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
            <div class="pointer" @click="changeGender('女性', influencer.ig_id, index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
            <div class="pointer" @click="changeGender('男性', influencer.ig_id, index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
            <div class="pointer" @click="changeGender('その他', influencer.ig_id, index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
            <div class="pointer" @click="(gender_check = true), openDrawer(influencer.account_name, 'instagram', index, true)">Check</div>
          </div>
          <div v-else>
            <div class="data-table-th-usergender" v-show="item.gender">{{ influencer.gender }}</div>
          </div>
          <div class="data-table-th-usergender" v-show="item.age">{{ influencer.age }}</div>
          <div class="data-table-th-num" v-if="item.age && admin_mode && activate == 20">
            <div class="data-table-birthday" @click="changeBirthday('', influencer.ig_id, index)">未設定</div>
            <div
              v-for="(birthday, birth_index) in influencer.pre_est_birthday"
              :key="birth_index"
              class="data-table-birthday"
              :class="[birthday.unlikely ? 'unlikely' : '', influencer.est_birthday == birthday.birthday ? 'active' : '']"
              @click="changeBirthday(birthday.birthday, influencer.ig_id, index)"
            >
              {{ birthday.birthday }}
            </div>
            <div v-if="influencer.pre_est_birthday" @click="(age_check = true), openDrawer(influencer.account_name, index, 'instagram', true)">Check</div>
            <div><a :href="'https://www.google.com/search?q=' + influencer.name + '+生年月日'" target="_blank">Google</a></div>
            <div @click="inputBirthday(influencer.ig_id, index)">手動入力</div>
          </div>
          <div class="data-table-th-gender" v-show="item.area">
            <div v-if="influencer.related_area">
              <font-awesome-icon icon="map-marker-alt" style="font-size:12px; margin-right:5px; color:#aaa" />
              <span v-for="area in influencer.related_area.area_data" :key="area.id" style="margin-right:5px">{{ area.area_name }}</span>
            </div>
          </div>
          <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width">
            <span v-html="$options.filters.searchHighlight(influencer.name, i_search.keyword)"></span>
            <pre v-html="$options.filters.searchHighlight(influencer.biography, i_search.keyword ? i_search.keyword : (i_search.category.length > 0 ? getCategoryName(i_search.category) : ''))"></pre>
            <a
              :href="influencer.website"
              v-show="(admin_mode && activate == 20) || i_search.weblink"
              class="router-link"
              target="_blank"
              v-html="$options.filters.searchHighlight(influencer.website, i_search.weblink)"
            ></a>
          </div>
          <div class="data-table-th-num" v-show="item.followers">{{ influencer.followers }}</div>
          <div class="data-table-th-eg" v-show="item.followers_growth_rate_90">{{ influencer.followers_growth_rate_90 }}%</div>
          <div class="data-table-th-num" v-show="item.following">{{ influencer.following }}</div>
          <div class="data-table-th-eg" v-show="item.average_like">
            <template v-if="influencer.is_estimated_engagement_insufficient === true">データ不足</template>
            <template v-else>{{ influencer.average_like }}</template>
          </div>
          <div class="data-table-th-eg" v-show="item.average_comments">{{ influencer.average_comments }}</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_rate">{{ influencer.median_video_play_rate }}%</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_rate_organic">{{ influencer.median_video_play_rate_organic }}%</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_rate_pr">{{ influencer.median_video_play_rate_pr }}%</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_count">{{ influencer.median_video_play_count }}</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_count_organic">{{ influencer.median_video_play_count_organic }}</div>
          <div class="data-table-th-eg" v-show="item.median_video_play_count_pr">{{ influencer.median_video_play_count_pr }}</div>
          <div class="data-table-th-eg" v-show="item.egr">
            <template v-if="influencer.is_estimated_engagement_insufficient === true">データ不足</template>
            <template v-else>{{ influencer.average_engagement_rate }}%</template>
          </div>
          <div class="data-table-th-eg" v-show="item.pr_rate">{{ influencer.pr_rate }}%</div>
          <div class="data-table-th-gender" v-show="item.gender_ratio">
            <genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" />
          </div>
          <div class="data-table-th-num" v-show="item.main_audience">
            <div v-if="influencer.main_audience">
              {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
            </div>
            <div v-else>-</div>
          </div>
          <div class="data-table-th-tag" v-show="item.tag">
            <customizeTag :id="influencer.ig_id" :sns_type="'instagram'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
          </div>
          <div class="data-table-th-photo hover pointer" v-show="item.recent_post" @click="openDrawer(influencer.account_name, index, 'instagram', true)">
            <div class="category">
              <div class="category-box-photoarea" v-for="(post, post_index) in influencer.category_post" v-bind:key="post.id">
                <img v-show="post"
                  :src="s3BaseUrl + '/postdata/' + post + '_s.jpg'"
                  class="category-box-img"
                  @error="imgErrorPost(index, post_index)"
                  :id="index + '-' + post_index"
                />
              </div>
            </div>
          </div>
          <div class="data-table-th-140" v-if="item.created_at">{{ influencer.created_at }}</div>
          <div class="data-table-th-80" v-if="item.score">{{ influencer.score }}</div>
          <div class="data-table-th-ranking" v-if="(i_search.keyword && i_search.keyword.trim() !== '') || i_search.category.length > 0">
            <div class="category">
              <div class="data-table-th-ranking-box">
                <div class="data-table-th-ranking-bar" :style="'width:' + influencer.ranking + '%'" v-if="i_search.keyword"></div>
                <div class="data-table-th-ranking-bar" :style="'width:' + influencer.category_ratio + '%'" v-else></div>
              </div>
            </div>
          </div>
          <div class="data-table-th-category" v-show="item.category">
            <div class="category" v-if="influencer.category_arr">
              <div class="category-box-list" v-for="category in influencer.category_arr.category_data" v-bind:key="category.id">&nbsp;{{ category.category_name }}({{ category.category_ratio }}%)</div>
            </div>
          </div>
          <div class="data-table-th-attribute" v-show="item.attribute_person_title" >
            <attributeMapping
                :id="influencer.ig_id"
                :attribute_sns_type=1
                :attributes="influencer.attributes"
                :attribute_id=1
                :influencer_index="index"
                :editMode="editMode"
                @updateAttributeProperties="updateAttributeProperties"
            />
          </div>
          <div class="data-table-th-attribute" v-show="item.attribute_specialty_categories_genres">
            <attributeMapping
                :id="influencer.ig_id"
                :attribute_sns_type=1
                :attributes="influencer.attributes"
                :attribute_id=2
                :influencer_index="index"
                :editMode="editMode"
                @updateAttributeProperties="updateAttributeProperties"
            />
          </div>
          <div class="data-table-th-attribute" v-show="item.attribute_post_format">
            <attributeMapping
                :id="influencer.ig_id"
                :attribute_sns_type=1
                :attributes="influencer.attributes"
                :attribute_id=3
                :influencer_index="index"
                :editMode="editMode"
                @updateAttributeProperties="updateAttributeProperties"
            />
          </div>
          <div class="data-table-th-num" v-show="item.report_count">{{ influencer.report_count }}</div>
          <div class="data-table-th-eg" v-show="item.avg_report_egr">{{ influencer.avg_report_egr }}%</div>
          <div class="data-table-th-num" v-show="item.avg_report_reach_count">{{ influencer.avg_report_reach_count }}</div>
          <div class="data-table-th-num" v-show="item.avg_report_like_count">{{ influencer.avg_report_like_count }}</div>
          <div class="data-table-th-num" v-show="item.avg_report_comments_count">{{ influencer.avg_report_comments_count }}</div>
          <div class="data-table-th-num" v-show="item.avg_report_saves_count">{{ influencer.avg_report_saves_count }}</div>
          <div class="data-table-th-num" v-show="item.avg_report_cost">{{ influencer.avg_report_cost }}</div>
          
        </div>
      </div>

      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more" style="font-size:40px;"></div>
        <div slot="no-results" style="font-size:40px;"></div>
      </infinite-loading>
      <div class="i-detail-modal" :class="[drawer ? 'open' : '', printmode ? 'print' : '']" id="i-detail-scroll">
        <router-view
          ref="iDetail"
          v-show="drawer"
          @favoriteReactive="favoriteReactive"
          @addInfluencerReactive="addInfluencerReactive"
          @deleteInfluencerReactive="deleteInfluencerReactive"
          @tagReactive="tagReactive"
          @storiesReactive="storiesReactive"
        ></router-view>
      </div>
      <div class="overlay" :class="drawer ? 'open' : ''" @click="closeDrawer"></div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const searchAPI = root + "/api/search/search";
const checkIndexProgressAPI = root + "/api/search/check";
const addFavoriteAPI = root + "/api/list/add_favorite";
const changeGenderAPI = root + "/api/admin/change_gender";
const changeBirthdayAPI = root + "/api/admin/change_birthday";
import favorite from "../list/favorite";
import genderRatio from "../list/gender_ratio";
import listIn from "../list/list_in";
import addListButton from "../list/add_list_button";
import tableColumn from "./table_column";
import windowSwitch from "../list/window_switch";
import snsIconList from "./sns_icon_list.vue";
import customizeTag from "./customize_tag";
import stories from "./stories";
import attributeMapping from "./attribute_mapping";
import { isObjEmpty } from "../../utils/common";
import { formatResultCountRange } from "@/utils/resultCountRange";

export default {
  name: "influencer",
  components: {
    favorite,
    genderRatio,
    listIn,
    addListButton,
    tableColumn,
    windowSwitch,
    snsIconList,
    customizeTag,
    stories,
    attributeMapping
  },
  data() {
    return {
      list: [],
      count: 0,
      result_count: 0,
      category: "",
      sort_key: "",
      sort_order: "",
      infiniteId: +new Date(),
      checkList: [],
      checkAll_val: false,
      checkedCount: 0,
      noinfluencer: false,
      noindex: false,
      index_create_progress: 0,
      default_search: false,
      sort_type: "",
      drawer: false,
      item: {
        account_name: true,
        gender: false,
        age: false,
        sns: true,
        bio: true,
        area: false,
        followers: true,
        followers_growth_rate_90: true,
        median_video_play_rate: true,
        median_video_play_rate_organic: true,
        median_video_play_rate_pr: true,
        median_video_play_count: false,
        median_video_play_count_organic: false,
        median_video_play_count_pr: false,
        egr: true,
        pr_rate: true,
        gender_ratio: this.view_influencer_audience_enabled,
        main_audience: false,
        recent_post: true,
        category: false,
        attribute_person_title: false,
        attribute_specialty_categories_genres: false,
        attribute_post_format: false,
        report_count: false,
        avg_report_egr: false,
        avg_report_reach_count: false,
        avg_report_like_count: false,
        avg_report_comments_count: false,
        avg_report_saves_count: false,
        avg_report_cost: false
      },
      router_link: "",
      data_table_width: "",
      max_width: "100%",
      account_name_width: "",
      requestId: 0,
      next_cursor: "",
      before_keyword: "",
      age_check: false,
      gender_check: false,
      intervalId: null,
      other_sns_type: "",
      mountedLoad: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode() {
      // if (this.admin_mode) {
      //   return true;
      // } else {
      //   return false;
      // }
      return false;
    },
    activate() {
      return this.$store.state.activate;
    },
    editMode() {
      return this.$store.state.edit_mode;
    },
    form() {
      return this.$store.state.form;
    },
    i_search() {
      return this.$store.state.i_search;
    },
    window_switch() {
      return this.$store.state.window_switch;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    item_info() {
      var info = {
        item: this.item,
        sort_key: this.sort_key,
        sort_order: this.sort_order,
      };
      return info;
    },
    view_influencer_audience_enabled() {
      return this.$store.state.service_plan.view_influencer_audience_enabled ? true : false;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
    recentPost1month: {
      get() {
        return !!this.$store.state.recent_post_1month;
      },
      set(val) {
        const checked = !!val;
        this.$store.dispatch("recent_post_1month", checked);
        this.$store.dispatch("i_search", { has_recent_post_1month: checked });
        this.$store.dispatch("form", {
          ...this.form,
          has_recent_post_1month: checked,
        });
        this.loadQuery();
      },
    },
    resultCountRange() {
      return formatResultCountRange(this.result_count);
    },
    displayResultCount() {
      return this.admin_mode ? this.result_count : this.resultCountRange;
    },
  },
  mounted() {
    this.$store.dispatch("changeActive", "i_search");
    window.addEventListener("resize", this.calcWidth);
    // mounted時のみformが更新されたらリロードを行う為のフラグ
    this.mountedLoad = true;
  },
  methods: {
    loadQuery() {
      this.infiniteId += 1;
      this.scrollTop();
      this.sort_order = "desc";
      this.sort_key = "followers_count";
      if (this.i_search.keyword != "") {
        this.sort_order = "desc";
        this.sort_key = "keyword";
      } else if (this.i_search.category.length > 0) {
        this.sort_order = "desc";
        this.sort_key = "category";
      }
      if (this.i_search.keyword != this.before_keyword) {
        this.next_cursor = "";
        this.before_keyword = this.i_search.keyword;
      }
      if (!(this.i_search.age[0] == 15 && this.i_search.age[1] == 55)) this.item.age = true;
      if (this.i_search.main_audience) this.item.main_audience = true;
      if (this.i_search && this.i_search.tags.length) this.item.tag = true;
      if (this.i_search.gender_null) {
        this.item.age = true;
        this.item.gender = true;
        this.item.created_at = true;
        this.sort_key = "created_at";
      }
      this.default_search = false;
      this.list = [];
      this.checkList = [];
      this.checkAll_val = false;
      this.count = 0;
      this.result_count = 0;
      this.other_sns_type = this.i_search.other_sns_type;
      if (!isObjEmpty(this.i_search.person_title)) this.item.attribute_person_title = true;
      if (!isObjEmpty(this.i_search.specialty_categories_genres)) this.item.attribute_specialty_categories_genres = true;
      if (!isObjEmpty(this.i_search.post_format)) this.item.attribute_post_format = true;
    },
    infiniteHandler($state) {
      
      // パラメータがセットされていない場合はリクエストをしない
      if(Object.keys(this.i_search).length === 0) return;
      
      this.noinfluencer = false;
      this.noindex = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("params", JSON.stringify(this.i_search));
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("next_cursor", this.next_cursor);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      this.axios
        .post(searchAPI, params, { requestId: this.requestId })
        .then((response) => {
          this.cancelSource = null;
          if (this.count == 0) {
            this.result_count = response.data.result_count;
            this.$store.dispatch("form", {
              ...this.form,
              has_recent_post_1month: this.recentPost1month,
            });
            this.list = response.data;
            this.count += 20;
            this.$nextTick(() => {
              this.calcWidth(); //テーブルの横サイズを取得
            });
            $state.loaded();
          } else {
            var newinfluencer = this.list.influencer.concat(response.data.influencer);
            this.list.influencer = newinfluencer;
            this.count += 20;
            $state.loaded();
          }
          if (this.count >= this.result_count) $state.complete();
          if (this.result_count == 0) this.noinfluencer = true;
          if (response.data.noindex) {
            this.noindex = true;
            this.index_create_progress = response.data.index_create_progress;
          }
        })
        .catch(() => {});
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.sort_key = value;
      this.list = [];
      this.count = 0;
      this.infiniteId += 1;
    },
    clearList() {
      this.checkAll_val = false;
      this.checkList = [];
    },
    checkAll() {
      const allInfluencer = [];
      const influencer_list = this.list.influencer;
      for (let i = 0; i < influencer_list.length; i++) {
        allInfluencer[i] = influencer_list[i].ig_id;
      }
      if (this.checkAll_val) {
        this.checkList = allInfluencer;
      } else {
        this.checkList = [];
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openDrawer(value, index, sns_type, default_search) {
      this.drawer = true;
      if (this.i_search.keyword) {
        var keyword = this.i_search.keyword;
        var search_type = "keyword";
      } else if (this.i_search.category.length > 0) {
        keyword = this.i_search.category;
        search_type = "category";
      } else if (this.age_check && this.admin_mode) {
        keyword = "歳を迎えました|歳になりました|才になりました|歳も頑張ります|歳もがんばります|歳の誕生日";
        search_type = "keyword";
      } else if (this.gender_check && this.admin_mode) {
        search_type = "gender_check";
      } else {
        keyword = "";
        search_type = "all";
      }
      document.documentElement.style.overflow = "hidden";
      this.$router.push({
        name: "instagram_influencerDetailDrawer",
        params: {
          account_name: value,
          influencer_index: index,
          child: true,
          default_search: default_search,
          parent_component: "instagram",
          search_keyword: keyword,
          search_type: default_search ? search_type : "all",
        },
      });
    },
    openNewWindow(value, sns_type) {
      let routeData = this.$router.resolve({
        name: sns_type == "instagram" ? "influencerDetail" : "youtuberDetail",
        params: {
          account_name: value,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeDrawer() {
      this.drawer = false;
      this.age_check = false;
      this.gender_check = false;
      document.documentElement.style.overflow = "auto";
      this.$refs.iDetail.closeParentDrawer();
      this.$router.push({
        name: "influencer",
        params: {
          backpage: true,
        },
      });
    },
    changeGender(command, ig_id, index) {
      this.axios.get(changeGenderAPI, {
        params: {
          id: ig_id,
          sns_type: "instagram",
          gender: encodeURI(command == "" ? "null" : command),
          token: this.token,
        },
      });
      this.list.influencer[index].gender = command;
    },
    changeBirthday(birthday, ig_id, index) {
      this.axios.get(changeBirthdayAPI, {
        params: {
          ig_id: ig_id,
          birthday: encodeURI(birthday == "" ? "null" : birthday),
          token: this.token,
        },
      });
      if (birthday != "") {
        let now = new Date().getFullYear() * 10000 + (new Date().getMonth() + 1) * 100 + new Date().getDate();
        let birth = Number(birthday.replaceAll("-", ""));
        var age = Math.floor((now - birth) / 10000);
      } else {
        age = "";
      }
      this.list.influencer[index].est_birthday = birthday;
      this.list.influencer[index].age = age;
      this.$forceUpdate();
    },
    inputBirthday(ig_id, index) {
      this.$prompt("誕生日を入力(yyyy-mm-ddで入力)", "誕生日を手動入力", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      })
        .then(({ value }) => {
          var v = value.match(/([0-9]{4})(-|年|\/|\.)([0-9]{1,2})(-|月|\/|\.)([0-9]{1,2})/);
          var y = v[1];
          var m = v[3];
          var d = v[5];
          if (m.length == 1) m = "0" + m;
          if (d.length == 1) d = "0" + d;
          var date = y + "-" + m + "-" + d;
          if (date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
            this.changeBirthday(date, ig_id, index);
            this.$message({
              type: "success",
              message: "誕生日を" + date + "に変更しました",
            });
          } else {
            this.$message({
              type: "success",
              message: "不正な値です",
            });
          }
        })
        .catch(() => {});
    },
    changeFavorite(index) {
      if (this.list.influencer[index].favorite == 0) {
        this.list.influencer[index].favorite = 1;
      } else {
        this.list.influencer[index].favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.list.influencer[index].ig_id);
      params.append("sns_type", "instagram");
      params.append("favorite", this.list.influencer[index].favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
    },
    favoriteReactive(index, favorite) {
      this.list.influencer[index].favorite = favorite;
    },
    storiesReactive(index, stories) {
      this.list.influencer[index].stories = stories;
    },
    addInfluencerReactive(index, list_name, list_id) {
      let object = {
        list_name: list_name,
        list_id: list_id,
      };
      if (this.list.influencer[index]) {
        if (!this.list.influencer[index].list_in) {
          this.list.influencer[index].list_in = [];
        }
        this.list.influencer[index].list_in.push(object);
        this.list.influencer[index].list_count += 1;
      }
    },
    deleteInfluencerReactive(index, list_id) {
      if (this.list.influencer[index]) {
        let list_in = this.list.influencer[index].list_in;
        for (let i = 0; i < list_in.length; i++) {
          if (list_in[i].list_id == list_id) {
            this.list.influencer[index].list_in.splice(i, 1);
          }
        }
        this.list.influencer[index].list_count -= 1;
      }
    },
    updateTag(type, tag_index, new_tag, influencer_index) {
      if (type == "add") {
        this.list.influencer[influencer_index].tags.push(new_tag);
      } else if (type == "delete") {
        this.list.influencer[influencer_index].tags.splice(tag_index, 1);
      }
    },
    tagReactive(id, type, tag_index, new_tag) {
      var id_type = "ig_id";
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list.influencer[i][id_type] == id) {
          if (type == "add") {
            this.list.influencer[i].tags.push(new_tag);
          } else if (type == "delete") {
            this.list.influencer[i].tags.splice(tag_index, 1);
          }
        }
      }
    },
    calcWidth() {
      const account_width = this.result_count > 0 ? document.getElementById("item_tr_name").getBoundingClientRect().width : 0;
      this.account_name_width = account_width + 80 + "px";
      let sum = 0;
      for (let key of Object.keys(this.item)) {
        const width = document.getElementById("item_" + key) ? document.getElementById("item_" + key).getBoundingClientRect().width : 0;
        sum += width;
      }
      this.data_table_width = sum + 80 + "px";
    },
    windowSwitch() {
      this.$store.dispatch("windowSwitch");
    },
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    imgError(index) {
      this.list.influencer[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    imgErrorPost(index, post_index) {
      var img = document.getElementById(index + "-" + post_index);
      img.setAttribute("src", this.s3BaseUrl + "/postdata/img_error_post_s.jpg");
    },
    checkIndexProgressInterval() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.checkIndexProgress, 5000);
    },
    checkIndexProgress() {
      this.axios
        .get(checkIndexProgressAPI, {
          params: {
            search_keyword: this.i_search.keyword,
            target_type: "influencer",
            sns_type: "instagram",
          },
        })
        .then((response) => {
          this.index_create_progress = response.data.index_create_progress;
          if (this.index_create_progress == 100) {
            clearInterval(this.intervalId);
            this.list = [];
            this.count = 0;
            this.infiniteId += 1;
          }
        })
        .catch(() => {});
    },
    updateAttributeProperties(type, attributeId, new_attributes, influencer_index) {
      if (type == "add") {
        this.list.influencer[influencer_index].attributes = new_attributes;
      } else if (type == "delete") {
        this.list.influencer[influencer_index].attributes = new_attributes;
      }
    },
    getCategoryName(category) {
      if (Array.isArray(category)) {
        return category.map(item => item.slice(-1)[0]).join(' ')
      } else {
        return category;
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.calcWidth);
    clearInterval(this.intervalId);
  },
  watch: {
    $route(to) {
      clearInterval(this.intervalId);
      if (to.name == "influencer" && !this.$route.params.backpage) {
        this.drawer = false;
        this.loadQuery();
      }
    },
    item: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
      deep: true,
    },
    noindex() {
      if (this.noindex) {
        this.checkIndexProgressInterval();
      } else {
        clearInterval(this.intervalId);
      }
    },
    form() {            
      // mounted時のみformが更新かつパラメータがセットされていたらリロードを行う。
      let form_length = Object.keys(this.form).length;
      if(form_length >= 20 && this.mountedLoad === true) {
        this.$store.dispatch("i_search", {
          ...this.form,
          has_recent_post_1month: !!this.$store.state.recent_post_1month,
        });
        this.loadQuery();  
        this.mountedLoad = false;
      }
    }
  },
  filters: {
    searchHighlight(value, keyword) {
      if (keyword) {
        const keyword_rep1 = keyword.replace(/OR/g, "|");
        const keyword_rep2 = keyword_rep1.replace(/"/g, "");
        const keyword_rep3 = keyword_rep2.replace(/\s/g, "|");
        const keyword_RegExp = new RegExp(keyword_rep3, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="data-table-th-highlight">' + keyword + "</span>");
      }
      return value;
    },
  },
};
</script>
<style>
.data-table-quick-filter .el-checkbox__label {
  display: inline !important;
  padding-left: 0;
}
</style>